const defaultPieChartColors = [
    '#00aeef',
    '#006de3',
    '#CC7830',
    '#9E54C0',
    '#339699',
    '#66738F',
    '#D367BD',
    '#6D7C4C',
    '#DD6367',
    '#7868CE',
    '#17A67B',
    '#3289C8',
    '#BE5407',
]

export const clientThemeBarclays = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#00aeef',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#00aeef',
        userIcon: '#FF3B29',
        brandLogo: {
            maxWidth: '150px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#a1a1aa',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '#00aeef',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#00aeef',
        stroke: '#00aeef',
        lineCharts: {
            stroke: '#00aeef',
            fill: '#00aeef',
        },
        areaCharts: {
            gradient: {
                start: '#00aeef',
                stop: '#00aeef',
            },
            stroke: '#00aeef',
            fill: '#00aeef',
            chargebacksByPostDateChart: {
                stroke: '#00aeef',
                fill: '#00aeef',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#CC7830',
                    fill: '#CC783020',
                },
                {
                    stroke: '#00aeef',
                    fill: '#00aeef20',
                },
                {
                    stroke: '#9E54C0',
                    fill: '#9E54C020',
                },
                {
                    stroke: '#339699',
                    fill: '#33969920',
                },
                {
                    stroke: '#66738F',
                    fill: '#66738F20',
                },
                {
                    stroke: '#D367BD',
                    fill: '#D367BD20',
                },
                {
                    stroke: '#6D7C4C',
                    fill: '#6D7C4C20',
                },
            ],
        },
        barCharts: {
            fill: '#006de3',
            lowestBar: '#E63C4F',
            byPlatformBarChart: { fill: '#006de3' },
            byBinBarChart: { fill: '#006de3' },
            ertsByRevenueChart: {
                bar1Fill: '#006de3',
                bar2Fill: '#00aeef',
            },
            averageTimetoFileDispute: { fill: '#00aeef' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#00aeef',
                lineColor: '#006de3',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#00aeef',
                mid: '#DAD7E2',
                high: '#9E54C0',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#00aeef',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#00aeef',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#00aeef',

            '&:hover': {
                backgroundColor: '#00aeef',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    select: {
        hover: {
            color: 'inherit',
            backgroundColor: '#F4F4F4',
        },
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 500,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#00aeef',
    primaryLight: '#33bef2',
    primary: '#00aeef',
    primaryDark: '#0079a7',
    secondaryLight: '#338ae8',
    secondary: '#006de3',
    secondaryDark: '#004c9e',
    hyperlink: '#00aeef',
    textField: '#00aeef',
    switch: '#00aeef',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(9, 167, 209, .4)',
    },
}
